// function selectRandomElementFromMaxValue =>
// Génère les nombre de 0 à 'max' et selectionne une des valeurs générée
// Parameters :
// max : nombre maximum parmis les valeurs à sélectionner
// excludedValues : valeurs à éxclure lors de la selection aléatoire

function selectRandomElementFromMaxValue (max, excludedValues) {
  const values = []
  for (let i = 0; i < max; i++) {
    values.push(i)
  }
  const filteredValues = values.filter(item => !excludedValues.includes(item))
  const randomElement = filteredValues[Math.floor(Math.random() * filteredValues.length)]
  return randomElement
}

function getRandomInt (max) {
  return Math.floor(Math.random() * Math.floor(max))
}

export {
  selectRandomElementFromMaxValue,
  getRandomInt
}
